import React from 'react';
import {StudentUploadComponent} from 'cl-library'

export default function Home() {	

  return(
    <>
    <StudentUploadComponent/>
    </>
  );
}